// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"chip_ko-KR__qcSNG","impressionTrackingContainer":"chip_impressionTrackingContainer__39JW0","chip":"chip_chip__XcOvj","chip__lines":"chip_chip__lines__bGKyR"};